/* AppListingPageSkeleton.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"],
  _excluded13 = ["as", "style"],
  _excluded14 = ["as", "style"],
  _excluded15 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _29 = "@media (min-width:48rem){._1xlogad4{height:5.5rem}}";
const _28 = "._4t3iqvp6{height:13.5rem}";
const _27 = "._1bsbn7od{width:unset}";
const _26 = "._p12fdmrr{max-width:38.5625rem}";
const _25 = "._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}";
const _24 = "._tzy4105o{opacity:.5}";
const _23 = "._19pkutpp{margin-top:var(--ds-space-150,9pt)}";
const _22 = "._bfhkmuej{background-color:var(--ds-border,#091e4224)}";
const _21 = "._1bsb1osq{width:100%}";
const _20 = "._4t3i133k{height:.125rem}";
const _19 = "._gy1pxy5q{column-gap:var(--ds-space-400,2pc)}";
const _18 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _17 = "@media (min-width:48rem){._b8yq19uw{max-width:12.5rem}}";
const _16 = "._4cvr1h6o{align-items:center}";
const _15 = "._gy1pu2gc{column-gap:var(--ds-space-100,8px)}";
const _14 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _13 = "._i0dlf1ug{flex-basis:0%}";
const _12 = "._1o9zkb7n{flex-shrink:1}";
const _11 = "._16jlkb7n{flex-grow:1}";
const _10 = "@media (min-width:48rem){._1xlo12bs{height:4rem}._14b512bs{width:4rem}}";
const _9 = "@media (min-width:48rem){._1xlots0x{height:5.75rem}._14b5ts0x{width:5.75rem}}";
const _8 = "._1bsb1k7u{width:3.5rem}";
const _7 = "._4t3i1k7u{height:3.5rem}";
const _6 = "@media (min-width:64rem){._1inivrvc{flex-direction:row}}";
const _5 = "._1p57xy5q{row-gap:var(--ds-space-400,2pc)}";
const _4 = "._2lx21bp4{flex-direction:column}";
const _3 = "._1bah1yb4{justify-content:space-between}";
const _2 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { breakpointValues, Stripe, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { AtlassianProductHostingType } from '@atlassian/mpac-types';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._19pk1jfw{margin-top:var(--ds-space-500,40px)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const Flex = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Flex.displayName = 'Flex';
}
const HeaderContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _2lx21bp4 _1p57xy5q _1inivrvc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderContainer.displayName = 'HeaderContainer';
}
const AppIconMPAC = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = Stripe,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1k7u _1bsb1k7u _1xlots0x _14b5ts0x", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppIconMPAC.displayName = 'AppIconMPAC';
}
const AppIconEMCEE = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = Stripe,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1k7u _1bsb1k7u _1xlo12bs _14b512bs", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppIconEMCEE.displayName = 'AppIconEMCEE';
}
const AppDetailsContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _2, _4, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _18u0u2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppDetailsContainer.displayName = 'AppDetailsContainer';
}
const AppDetailsRow = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppDetailsRow.displayName = 'AppDetailsRow';
}
const CTAContainer = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _gy1pu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CTAContainer.displayName = 'CTAContainer';
}
const CTAContainerEMCEE = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _4, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CTAContainerEMCEE.displayName = 'CTAContainerEMCEE';
}
const CTAButton = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = Stripe,
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _b8yq19uw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  CTAButton.displayName = 'CTAButton';
}
const TabsContainer = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabsContainer.displayName = 'TabsContainer';
}
const TabItemContainer = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _gy1pxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabItemContainer.displayName = 'TabItemContainer';
}
const TabSeparator = forwardRef((_ref13, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref13,
    __cmplp = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_20, _21, _22, _23, _24]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i133k _1bsb1osq _bfhkmuej _19pkutpp _tzy4105o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabSeparator.displayName = 'TabSeparator';
}
const TabContentContainer = forwardRef((_ref14, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref14,
    __cmplp = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_21, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq _otyr1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabContentContainer.displayName = 'TabContentContainer';
}
const SocialSignals = forwardRef((_ref15, __cmplr) => {
  let {
      as: C = Stripe,
      style: __cmpls
    } = _ref15,
    __cmplp = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_26, _27, _28, _29]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_p12fdmrr _1bsbn7od _4t3iqvp6 _1xlogad4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SocialSignals.displayName = 'SocialSignals';
}
const TabSkeleton = _ref16 => {
  let {
    tabCount = 6
  } = _ref16;
  return /*#__PURE__*/_jsxs(TabsContainer, {
    children: [/*#__PURE__*/_jsx(TabItemContainer, {
      children: new Array(tabCount).fill(/*#__PURE__*/_jsx(Stripe, {
        height: "1rem",
        width: "4.375rem"
      }))
    }), /*#__PURE__*/_jsx(TabSeparator, {})]
  });
};
const HeaderInjectionMPAC = _ref17 => {
  let {
    selectedHosting
  } = _ref17;
  return /*#__PURE__*/_jsxs(CTAContainer, {
    children: [selectedHosting !== AtlassianProductHostingType.Server && /*#__PURE__*/_jsx(CTAButton, {
      width: "6.5rem",
      height: "2.5rem",
      borderRadius: "var(--ds-radius-large, 8px)"
    }), selectedHosting === AtlassianProductHostingType.DataCenter && /*#__PURE__*/_jsx(CTAButton, {
      width: "6.5rem",
      height: "2.5rem",
      borderRadius: "var(--ds-radius-large, 8px)"
    }), /*#__PURE__*/_jsx(Stripe, {
      width: "2.5rem",
      height: "2.5rem",
      borderRadius: "var(--ds-radius-large, 8px)"
    })]
  });
};
const HeaderInjectionEMCEE = () => {
  return /*#__PURE__*/_jsx(Flex, {
    children: /*#__PURE__*/_jsxs(CTAContainerEMCEE, {
      children: [/*#__PURE__*/_jsx(Stripe, {
        width: "6rem",
        height: "2rem",
        borderRadius: "var(--ds-radius-large, 8px)"
      }), /*#__PURE__*/_jsx(Stripe, {
        width: "5rem",
        height: "0.875rem",
        marginTop: "var(--ds-space-075, 6px)"
      })]
    })
  });
};
export const AppListingTabContentSkeleton = () => /*#__PURE__*/_jsxs(TabContentContainer, {
  children: [/*#__PURE__*/_jsx(Stripe, {
    maxWidth: "20.5626rem",
    height: "1rem",
    marginTop: "var(--ds-space-400, 32px)"
  }), /*#__PURE__*/_jsx(Stripe, {
    maxWidth: "37.9375rem",
    height: "0.875rem",
    marginTop: "var(--ds-space-300, 24px)"
  })]
});
const getTabCount = _ref18 => {
  let {
    isEMCEE,
    isMobile,
    isAppReviewsEnabled
  } = _ref18;
  if (isEMCEE) {
    if (isAppReviewsEnabled) return 4;
    return 3;
  }
  if (isMobile) return 4;
  return 6;
};
export const AppListingPageSkeleton = _ref19 => {
  let {
    selectedHosting,
    isEMCEE = false
  } = _ref19;
  const {
    enableAppReviewsFromStoreBff
  } = useStatsig();
  const isAppReviewsEnabled = enableAppReviewsFromStoreBff();
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  const AppIcon = isEMCEE ? AppIconEMCEE : AppIconMPAC;
  return /*#__PURE__*/_jsxs(Container, {
    "data-testid": "app_listing_page_skeleton",
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(HeaderContainer, {
        children: [/*#__PURE__*/_jsxs(AppDetailsRow, {
          children: [/*#__PURE__*/_jsx(AppIcon, {}), /*#__PURE__*/_jsxs(AppDetailsContainer, {
            children: [/*#__PURE__*/_jsx(Stripe, {
              maxWidth: "25rem",
              height: "1rem"
            }), !isEMCEE && /*#__PURE__*/_jsx(Stripe, {
              maxWidth: "13.3125rem",
              height: "0.875rem",
              marginTop: "var(--ds-space-300, 24px)"
            }), /*#__PURE__*/_jsx(Stripe, {
              maxWidth: "13.3125rem",
              height: "0.875rem",
              marginTop: "var(--ds-space-200, 16px)"
            })]
          })]
        }), isEMCEE ? /*#__PURE__*/_jsx(HeaderInjectionEMCEE, {}) : /*#__PURE__*/_jsx(HeaderInjectionMPAC, {
          selectedHosting: selectedHosting
        })]
      }), /*#__PURE__*/_jsx(SocialSignals, {
        marginTop: "var(--ds-space-300, 24px)"
      }), !isEMCEE && /*#__PURE__*/_jsx(Stripe, {
        width: "9.75rem",
        height: "0.875rem",
        marginTop: "var(--ds-space-250, 20px)"
      }), selectedHosting === AtlassianProductHostingType.Server && /*#__PURE__*/_jsx(Stripe, {
        width: "100%",
        height: "5rem",
        marginTop: "var(--ds-space-250, 20px)"
      })]
    }), /*#__PURE__*/_jsx(TabSkeleton, {
      tabCount: getTabCount({
        isEMCEE,
        isMobile,
        isAppReviewsEnabled
      })
    }), /*#__PURE__*/_jsx(AppListingTabContentSkeleton, {})]
  });
};